@use '../../custom-scroll/custom-scroll' as *;
@use '../../../design-tokens/border-radius/border-radius' as *;
@use '@design/design-tokens/breakpoints/breakpoints' as *;

@layer design-system {
  .dropdownListRoot {
    &.hasV2Styles {
      @include custom-scroll-minimal;
      max-height: min(30vh, 320px);
      box-shadow: var(--elevation-moderate);
      @include border-radius-r2;
      border: 1px solid var(--border-soft);
      background-color: var(--surface-default);

      overflow: hidden auto;
      padding: 1px;

      @include respond-to('mobile') {
        max-height: 80vh;
      }
    }
  }
}
